import { Button, Stack, Paper } from '@mui/material'
import Grid2 from '@mui/material/Unstable_Grid2/Grid2'
import React from 'react'
// import { Item } from './Item.js'
// import CircularProgress from '@mui/material/CircularProgress'

// TODO: 07/05/23 what is an item doing with elevation fix all all over proj
export default function BomGridButtonRow({
    // isDesktopDisplay,
    setOpenSummaryDlg,
    handleSaveToCart,
    // isLoading,
}) {
    const sxPropPaper = { px: { xs: 1, sm: 2 }, py: 2 }
    const sxPropBut = {} // { p: { xs: 0.25, sm: 2 } }
    return (
        <Grid2 container columns={20} xs={20}>
            <Grid2
                xs={20}
                // sx={{
                //     // textAlign: 'left',

                //     display: 'flex',
                //     justifyContent: 'flex-start',
                //     // borderTop: 0.1,
                //     // borderColor: 'companyColors.accent',

                //     // columnGap: '20px',
                //     '& .MuiButtonBase-root': {
                //         pl: 4,
                //         pr: 4,
                //         // minWidth: '18rem',
                //     },
                // }}
            >
                <Stack
                    direction="row"
                    sx={{
                        justifyContent: 'space-between',
                        alignContent: 'center',
                    }}
                >
                    <Paper elevation={0} sx={sxPropPaper}>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={sxPropBut}
                            onClick={() => setOpenSummaryDlg(true)}
                        >
                            Fence Summary
                        </Button>
                    </Paper>
                    {/*                    
                    TODO: 06/06/24  here or in Fence Summary?

                    possiblly helpful code.
                        const md = useMediaQuery(theme.breakpoints.down('md'))
                        const bkMk = md ? null : 'Ctrl or Cmd + D to bookmark'
                                       
                        <Typography
                            variant={'caption text'}
                            sx={{
                                fontSize: '85%',
                                mt: 0,
                                pt: 0,
                                textAlign: 'left',
                                pl: 2,
                            }}
                        >
                            {bkMk}
                        </Typography>
                    */}

                    {/*   
                    <Paper elevation={0} sx={sxPropPaper}>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={sxPropBut}
                            onClick={() => setOpenSummaryDlg(true)}
                        >
                            Bookmark Estimate
                        </Button>
                    </Paper> */}
                    <Paper elevation={0} sx={sxPropPaper}>
                        <Button
                            variant="contained"
                            color="primary"
                            sx={sxPropBut}
                            onClick={() => handleSaveToCart(true)}
                        >
                            Add to Cart
                        </Button>
                    </Paper>
                </Stack>
            </Grid2>
        </Grid2>
    )
}
